import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $createParagraphNode, $getRoot, $setSelection } from 'lexical';
import PropTypes from 'prop-types';
import { twJoin } from 'tailwind-merge';

import QuickComment from 'shopper/components/QuickComment';

import { sendEvent } from 'lib/gtag';
import { $generateNodesFromStr } from 'lib/textEditor';

import { useUser } from 'providers/UserProvider';

const GA_EVENT_CATEGORY = 'quick_answers';

const QuickComments = ({ className, messages }) => {
  const [editor] = useLexicalComposerContext();
  const { isLoggedIn, runCallbackIfLoggedIn } = useUser();

  const onAddQuickComment = (comment) => {
    runCallbackIfLoggedIn(() => {
      editor.update(() => {
        // Clears selection pointer when previous text was manually written
        $setSelection(null);

        const root = $getRoot();
        const paragraph = $createParagraphNode();
        const nodes = $generateNodesFromStr(comment, editor);

        nodes.map((node) => paragraph.append(node));
        root.getFirstChild().replace(paragraph);

        return true;
      });
    });
  };

  return (
    <div
      className={twJoin(
        'scrollbar-light flex w-full snap-x snap-mandatory items-center gap-x-2 overflow-x-auto scroll-smooth py-1 pl-px scrollbar-none md:flex-wrap md:gap-y-2 md:overflow-x-hidden',
        className
      )}
    >
      {messages.map(({ emojiLeft, gaEventCategory, text }) => (
        <QuickComment
          key={text}
          className="snap-center rounded-full border border-neutral-high-300 bg-transparent hover:border-transparent hover:bg-neutral-high-200 hover:ring-1 hover:ring-neutral-low-100 active:bg-neutral-high-300 dark:text-neutral-high-300 dark:hover:bg-neutral-low-300"
          emojiLeft={emojiLeft}
          type="secondary"
          onClick={() => {
            sendEvent({
              category: GA_EVENT_CATEGORY,
              action: isLoggedIn ? gaEventCategory : 'user_unlogged_attempt',
            });

            onAddQuickComment(`${emojiLeft} ${text}`);
          }}
        >
          {text}
        </QuickComment>
      ))}
    </div>
  );
};

QuickComments.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  messages: PropTypes.arrayOf(
    PropTypes.shape({
      emojiLeft: PropTypes.string.isRequired,
      gaEventCategory: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default QuickComments;
